import { makeActionCreator } from '../../configs/store/utils'

export const CLOSE_HISTORY_DIOALOG = 'CLOSE_HISTORY_DIOALOG'
export const onCloseHistoryDialog = makeActionCreator(CLOSE_HISTORY_DIOALOG)

export const SHOW_HISTORY_DIALOG = 'SHOW_HISTORY_DIALOG'
export const onShowHistoryDialog = makeActionCreator(SHOW_HISTORY_DIALOG)
